import React from 'react';
import ListItem from 'components/ListItem';
import { FertilizerTechnicalPersonName } from 'services/fertilizerEvents/types';

export interface OwnProps {
    technicalPersonName: FertilizerTechnicalPersonName;
}

type Props = OwnProps;

export default function SummaryApplicationTechnicalPersonName(
    props: Props
): React.ReactElement {
    const { technicalPersonName } = props;

    return (
        <ListItem
            description="Tech. responsible person"
            value={technicalPersonName}
        />
    );
}
